import React, { useState } from "react";
import { Link } from "react-router-dom";
import projectsData from "./ProjectData";

function Projects() {

  const [search, setSearch] = useState("");

  const filteredProjects = projectsData.filter((p) =>
    p.title.toLowerCase().includes(search.toLowerCase()) ||
    p.location.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>

     
     <div
  style={{
    position: "relative",
    marginTop: "20px",
    marginBottom: "40px"
  }}
>
  <img
    src={process.env.PUBLIC_URL + "/Images/map.jpeg"}
    alt="banner"
    style={{
      width: "100%",
      height: "auto",   
      display: "block",
      borderRadius: "10px"
    }}
  />

  {/* TEXT OVER IMAGE */}
  <div
    style={{
      position: "absolute",
      bottom: "20px",
      left: "50%",
      transform: "translateX(-50%)",
      textAlign: "center",
      color: "#fff",
      background: "rgba(0,0,0,0.5)",  
      padding: "10px 20px",
      borderRadius: "8px"
    }}
  >
    <h3 style={{ margin: 0 }}>Premium Residential Plots</h3>
    <p style={{ margin: 0 }}>Coonoor & Giris Garden</p>
  </div>
</div>

      <div className="container">

        {/* TITLE */}
        <h2 className="text-center fw-bold mb-2">
          Land for Sale
        </h2>

        <p className="text-center text-muted mb-4">
          Book Your Plot Today – Limited Availability!
        </p>

        {/* SEARCH */}
        <div className="row mb-4 justify-content-center">
          <div className="col-md-6">
            <input
              type="text"
              className="form-control shadow-sm"
              placeholder="Search location..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>

       
        <div className="row justify-content-center">

          {filteredProjects.map((project) => (
            <div className="col-md-5 mb-4" key={project.id}>

              <div
                className="card shadow-sm border-0 h-100"
                style={{
                  borderRadius: "12px",
                  overflow: "hidden"
                }}
              >

                <img
                  src={project.image}
                  alt={project.title}
                  style={{
                    height: "220px",
                    objectFit: "cover"
                  }}
                />

                <div className="card-body text-center">

                  <h5 className="fw-bold">{project.title}</h5>

                  <p className="text-muted mb-1">
                    📍 {project.location}
                  </p>

                  <p className="text-success fw-bold">
                    {project.price}
                  </p>

                  <Link
                    to={`/Projects/${project.id}`}
                    className="btn btn-dark btn-sm mt-2"
                  >
                    View Details
                  </Link>

                </div>

              </div>

            </div>
          ))}

        </div>

      </div>
    </div>
  );
}

export default Projects;